<script>
export default {
  name: "bg-image",

  bind(el, binding) {
    el.style.backgroundImage = "url(" + binding.value + ")";
  },

  update(el, binding) {
    el.style.backgroundImage = "url(" + binding.value + ")";
  },

  unbind(el) {
    el.style.backgroundImage = null;
  }
};
</script>
